<app-navbar></app-navbar>

<!-- Page Banner -->
<div class="rs-page-banner">
  <div class="rs-pb-deco">
    <div class="rs-pb-dots"></div>
    <div class="rs-pb-circle rs-pb-c1"></div>
    <div class="rs-pb-circle rs-pb-c2"></div>
  </div>
  <div class="container">
    <div class="rs-pb-content">
      <h1 class="rs-pb-title">Contact Us</h1>
      <nav class="rs-pb-breadcrumb">
        <a routerLink="/">Home</a>
        <i class="ri-arrow-right-s-line"></i>
        <span>Contact</span>
      </nav>
    </div>
  </div>
</div>

<!-- Content -->
<div class="rs-inner-page">
  <div class="container">
    <div class="row g-4 align-items-start">

      <!-- Left: Contact Info -->
      <div class="col-lg-5 col-md-12 wow fadeInLeft" data-wow-delay="0.2s">
        <div class="rs-contact-info-card">

          <div class="rs-inner-section-title" style="margin-bottom:24px;">
            <div class="rs-ist-sub"><i class="ri-map-pin-2-line"></i> Get in Touch</div>
            <h2>Contact Information</h2>
          </div>

          <div class="rs-contact-info-item">
            <div class="rs-ci-icon"><i class="ri-map-pin-2-line"></i></div>
            <div>
              <div class="rs-ci-label">Address</div>
              <div class="rs-ci-value">{{ contact_info?.Address }}</div>
            </div>
          </div>

          <div class="rs-contact-info-item">
            <div class="rs-ci-icon"><i class="ri-phone-line"></i></div>
            <div>
              <div class="rs-ci-label">Phone</div>
              <div class="rs-ci-value">{{ contact_info?.Phone }}</div>
            </div>
          </div>

          <div class="rs-contact-info-item">
            <div class="rs-ci-icon"><i class="ri-mail-line"></i></div>
            <div>
              <div class="rs-ci-label">Email</div>
              <div class="rs-ci-value">{{ contact_info?.Email }}</div>
            </div>
          </div>

          <!-- Social Links -->
          <ul class="rs-social-list">
            <li><a href="#"><i class="ri-facebook-fill"></i></a></li>
            <li><a href="#"><i class="ri-twitter-x-fill"></i></a></li>
            <li><a href="#"><i class="ri-youtube-fill"></i></a></li>
            <li><a href="#"><i class="ri-instagram-line"></i></a></li>
          </ul>

        </div>
      </div>

      <!-- Right: Map -->
      <div class="col-lg-7 col-md-12 wow fadeInRight" data-wow-delay="0.3s">
        <div class="rs-map-card">
          <iframe
            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2626.2858113847224!2d91.12814787352389!3d23.43901530066281!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x37547c260bc902e9%3A0x9be13436af366b91!2sCantonment%20Board%20Secondary%20School!5e1!3m2!1sen!2sbd!4v1789015432555!5m2!1sen!2sbd"
            allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade">
          </iframe>
        </div>
      </div>

    </div>
  </div>
</div>
